import React from 'react';
import PropTypes from 'prop-types';

// material-ui components
import withStyles from '@material-ui/core/styles/withStyles';
import { Card, CardActions, CardContent, CardHeader, Typography } from '@material-ui/core';

import statsCardStyle from 'assets/jss/material-dashboard-pro-react/components/statsCardStyle';

function StatsCard({ ...props }) {
  const {
    classes,
    title,
    description,
    statLink,
    small,
    statText,
    statIconColor,
    iconColor,
  } = props;
  return (
    <Card className={classes.card}>
      <CardHeader
        classes={{
          root: `${classes.cardHeader} ${classes[`${iconColor}CardHeader`]}`,
          avatar: classes.cardAvatar,
        }}
        avatar={<props.icon className={classes.cardIcon} />}
      />
      <CardContent className={classes.cardContent}>
        <Typography component="p" className={classes.cardCategory}>
          {title}
        </Typography>
        <Typography
          component="h2"
          className={`headline ${classes.cardTitle}`}
        >
          {description}
          {' '}
          {small !== undefined ? (
            <small className={classes.cardTitleSmall}>{small}</small>
          ) : null}
        </Typography>
      </CardContent>
      <CardActions className={classes.cardActions}>
        <div className={classes.cardStats}>
          {props.statIcon && (
          <props.statIcon
            className={
              `${classes.cardStatsIcon 
              } ${ 
                classes[`${statIconColor}CardStatsIcon`]}`
            }
          />
          )}
          {' '}
          {statLink !== undefined ? (
            <a href={statLink.href} className={classes.cardStatsLink}>
              {statLink.text}
            </a>
          ) : statText !== undefined ? (
            statText
          ) : null}
        </div>
      </CardActions>
    </Card>
  );
}

StatsCard.defaultProps = {
  iconColor: 'orange',
  statIconColor: 'gray',
};

StatsCard.propTypes = {
  classes: PropTypes.object.isRequired,
  icon: PropTypes.func.isRequired,
  iconColor: PropTypes.oneOf(['orange', 'green', 'red', 'blue', 'purple']),
  title: PropTypes.node,
  description: PropTypes.node,
  small: PropTypes.node,
  statIcon: PropTypes.func,
  statIconColor: PropTypes.oneOf([
    'warning',
    'primary',
    'danger',
    'success',
    'info',
    'rose',
    'gray',
  ]),
  statLink: PropTypes.object,
  statText: PropTypes.node,
};

export default withStyles(statsCardStyle)(StatsCard);
